import * as yup from "yup";

export const CreateLeadTrackingScheama = yup.object().shape({
  name: yup.string().required("required"),
  quatationNumber: yup.string(),
  siLocation: yup.string().required("required"),
  clientContact: yup.string().required("required"),
  projectArea: yup.number(),
  clientEmail: yup.string().email("Please enter a valid email"),
});
